import { darken } from 'polished';
import styled from 'styled-components';

/**
 * Primitive condivise per il contenuto dei popover informativi
 * (help contestuali con testo esplicativo ed eventuali box di esempio).
 * Ogni popover compone queste primitive con il proprio contenuto specifico.
 */

/** Wrapper del contenuto del popover, limita la larghezza per leggibilità. */
export const InfoPopoverContentWrapper = styled.div`
  max-width: 320px;
`;

/** Paragrafo di testo esplicativo del popover. */
export const InfoPopoverText = styled.p`
  line-height: 1.35;
  margin: 0 0 12px;
`;

/** Griglia responsive per box di esempio affiancati. */
export const InfoPopoverExamplesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
`;

/** Box di esempio con sfondo e bordo in tinta con il layout. */
export const InfoPopoverExampleBox = styled.div`
  padding: 12px;
  border: 1px solid ${({ theme }) => darken(0.1, theme.colorBgLayout)};
  border-radius: 6px;
  background: ${({ theme }) => theme.colorBgLayout};
`;

/** Variante del box di esempio con contenuto centrato (caption + valore). */
export const InfoPopoverExampleValueBox = styled(InfoPopoverExampleBox)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
`;

/** Didascalia secondaria all'interno di un box di esempio. */
export const InfoPopoverExampleCaption = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colorTextSecondary};
  line-height: 1.35;
`;

/** Valore in evidenza all'interno di un box di esempio. */
export const InfoPopoverExampleValue = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colorText};
  line-height: 1.2;
`;
